// Not-found page

import { SiteLayout } from '@components/layout/SiteLayout';
import { FooterCtaBuildYourReliableBackend } from '@components/layout/FooterCtas';
import { SlideIn } from '@components/interactions';

export function NotFoundPage() {
  return (
    <SiteLayout banner={false} footerCta={<FooterCtaBuildYourReliableBackend />}>
      <section className="section_404">
        <SlideIn className="padding-global" as="div">
          <div className="container-large">
            <div className="padding-section-large padding-top">
              <div className="max-width-medium">
                <div className="text-align-center">
                  <div>
                    {/* The bottom margin it had as an <h1> (webflow.css gives h1s one; this page's h1 is below). */}
                    <div className="heading-style-h3 text-color-text" style={{ marginBottom: '15px' }}>
                      404 Error
                    </div>
                  </div>
                  <div className="margin-bottom margin-small">
                    <h1 className="heading-style-h1">Page not found</h1>
                  </div>
                  <div className="margin-bottom margin-small">
                    <p className="text-body-active">
                      {
                        "DBOS\u00a0guarantees durable, resilient execution for your applications, but even we can't serve a page that doesn't exist."
                      }
                    </p>
                  </div>
                  <div
                    data-wf--button--variant="secondary-large"
                    className="button-wrapper w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1"
                  >
                    <a href="/" className="button w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1 w-inline-block">
                      <div className="text-block-4 w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1">Return to Home</div>
                      <div className="icon-chevron-right w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1 w-embed">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          {'\n'}
                          <path
                            d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                            fill="#F3F6F8"
                          />
                          {'\n'}
                        </svg>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </SlideIn>
      </section>
    </SiteLayout>
  );
}
